import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "modal-title fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "modal-footer p-2"
}
const _hoisted_7 = { class: "row w-100" }
const _hoisted_8 = { class: "col-6 ps-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_10 = ["type"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-save" }, null, -1)
const _hoisted_12 = { class: "col-6 pe-0 text-end" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)

import { reactive, onMounted, watch, computed } from "vue";

//componentes
import { Modal } from "bootstrap";

interface IProps {
  id: string,
  exibir: boolean,
  botaoFechar?: boolean,
  botaoSim?: boolean,
  botaoNao?: boolean,
  botaoGravar?: boolean,
  botaoGravarTipo?: 'button' | 'submit'
  titulo?: string,
  classBody?: string,
  classHeader?: string,
  tamanho?: 'modal-sm' | 'modal-lg' | 'modal-xl'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    id: {},
    exibir: { type: Boolean },
    botaoFechar: { type: Boolean },
    botaoSim: { type: Boolean },
    botaoNao: { type: Boolean },
    botaoGravar: { type: Boolean },
    botaoGravarTipo: {},
    titulo: {},
    classBody: {},
    classHeader: {},
    tamanho: {}
  },
  emits: ["onSim", "onNao", "onOk", "onFechou", "onGravar"],
  setup(__props: any, { emit: __emit }) {


//vue
var props = __props;

const controle = reactive({
  id: props.id,
  modal: {} as Modal,
  exibir: false,
  titulo: props.titulo,
  tamanho: props.tamanho
});

var emit = __emit;

onMounted(() => {
  if (props.id == undefined || props.id == "")
    controle.id = "janMsgBox";
})

watch(() => props.id, async (novoValor) => {
  if (novoValor == undefined || novoValor == "")
    controle.id = "janMsgBox";
  else
    controle.id = novoValor;
})

watch(() => props.exibir, async (novoValor, antigoValor) => {

  console.log("watch exibir", novoValor, antigoValor);
  if (novoValor == true && novoValor != antigoValor) {
    controle.exibir = true;
    exibirModal();
    controle.tamanho = props.tamanho;
  }
  else
    fecharModal();
})

watch(() => props.titulo, async (novoValor) => {
  controle.titulo = novoValor;
})

watch(() => props.tamanho, async (novoValor) => {
  controle.tamanho = novoValor;
})

function exibirModal() {
  controle.modal = new Modal(`#${controle.id}`, {})
  controle.modal.show();
}

function fecharModal() {
  console.log("fecharModal");
  controle.modal.hide();
  emit("onFechou");
}

const temBotoes = computed(() => {
  return props.botaoFechar || props.botaoSim || props.botaoNao || props.botaoGravar;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: controle.id,
    tabindex: "-1",
    "data-bs-keyboard": "false",
    "data-bs-backdrop": "static"
  }, [
    _createElementVNode("div", _mergeProps({
      class: ["modal-dialog modal-dialog-centered", _ctx.tamanho ? _ctx.tamanho : '']
    }, _ctx.$attrs), [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-header d-flex justify-content-between", _unref(props).classHeader])
        }, [
          _createElementVNode("h5", _hoisted_3, _toDisplayString(!controle?.titulo ? 'Atenção' : controle.titulo), 1),
          _createElementVNode("a", {
            type: "button",
            class: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (fecharModal()))
          }, _hoisted_5)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["modal-body", _unref(props).classBody])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2),
        (temBotoes.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_unref(props).botaoSim)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "btn btn-primary btn-sm",
                        onClick: _cache[1] || (_cache[1] = () => { _unref(emit)('onSim'); fecharModal(); })
                      }, [
                        _hoisted_9,
                        _createTextVNode(" Sim ")
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(props).botaoGravar)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-primary btn-sm",
                        onClick: _cache[2] || (_cache[2] = () => { _unref(emit)('onGravar'); }),
                        type: _ctx.botaoGravarTipo ? _ctx.botaoGravarTipo : _ctx.botaoGravarTipo
                      }, [
                        _hoisted_11,
                        _createTextVNode(" Gravar ")
                      ], 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_unref(props).botaoNao)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "btn btn-secondary btn-sm",
                        onClick: _cache[3] || (_cache[3] = () => { _unref(emit)('onNao'); fecharModal(); })
                      }, [
                        _hoisted_13,
                        _createTextVNode(" Não ")
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(props).botaoFechar)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "btn btn-secondary btn-sm",
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (fecharModal()))
                      }, [
                        _hoisted_14,
                        _createTextVNode(" Fechar ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 16)
  ], 8, _hoisted_1))
}
}

})